import { roundUpPrice } from '@/utils/circuits/prices/formatPrice';
import { ColumnDef } from '@tanstack/react-table';
import { Translator } from '../translator.type';

export type DistributorEstimateStats = {
  id: string;
  name: string;
  reserved: number;
  inWait: number;
  received: number;
  pending: number;
  transformationRateInWait: number;
  transformationRateReceived: number;
  transformationRatePending: number;
};

export const DISTRIBUTORS_ESTIMATE_STATS_COLUMNS = (
  t: Translator,
): ColumnDef<DistributorEstimateStats>[] => [
  {
    accessorKey: 'name',
    header: t('stats.columns.name'),
  },
  {
    accessorKey: 'reserved',
    header: t('stats.columns.reserved'),
  },
  {
    accessorKey: 'inWait',
    header: t('stats.columns.inWait'),
  },
  {
    accessorKey: 'received',
    header: t('stats.columns.received'),
  },
  {
    accessorKey: 'pending',
    header: t('stats.columns.pending'),
  },
  {
    accessorKey: 'transformationRateInWait',
    header: t('stats.columns.transformationRateInWait'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRateInWait * 100)} %`}</span>
    ),
  },
  {
    accessorKey: 'transformationRateReceived',
    header: t('stats.columns.transformationRateReceived'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRateReceived * 100)} %`}</span>
    ),
  },
  {
    accessorKey: 'transformationRatePending',
    header: t('stats.columns.transformationRatePending'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRatePending * 100)} %`}</span>
    ),
  },
];
